import ajax from "./ajax";

export function getJobs() {
  return ajax(`/jobs?sort=display_order`);
}
